import script from "./VendorPictures.vue?vue&type=script&setup=true&lang=js"
export * from "./VendorPictures.vue?vue&type=script&setup=true&lang=js"

import "./VendorPictures.vue?vue&type=style&index=0&id=76cec7ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76cec7ee"]])

export default __exports__